/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';

import * as liveChatActionTypes from 'plugin/live-chat/action/liveChatActionTypes';

const initialState = { status: null };

const _setStatus = (state: string, action: Object) => {
  const { status } = action;
  return { ...state, status };
};

export default createReducer(initialState, {
  [liveChatActionTypes.LIVE_CHAT_UPDATE_STATUS]: _setStatus,
});
